import { Box } from '@mui/material';
import { Flex } from '../../../../base/components/Flex';
import {
  SceneParameter,
  SceneParameterValue,
} from '../../../../graphql/graphql-operations';
import { paramValueIconMap } from '../../../components/PlaylistBuilder/PlaylistLargeParam';

interface Props {
  param: SceneParameter;
  selectedId: string;
  onSelected: (id: string) => void;
  largeVersion?: boolean;
}

const QrLangSelect = ({
  param,
  selectedId,
  onSelected,
  largeVersion,
}: Props) => {
  const renderLang = (lang: SceneParameterValue) => {
    const icon = paramValueIconMap({
      sx: {
        fontSize: largeVersion ? '4rem' : '2.25rem',
        m: largeVersion ? 1 : 0.5,
        display: 'block',
      },
    })[param.name]?.[lang.name];

    return (
      <Box
        key={lang.id}
        onClick={() => onSelected(lang.id)}
        sx={{
          cursor: 'pointer',
          borderWidth: '1px',
          borderStyle: 'solid',
          color: 'grey.200',
          backgroundColor:
            selectedId === lang.id ? 'primary.lighter' : undefined,
          borderRadius: '100px',
          aspectRatio: '1/1',
        }}
      >
        {icon || lang.name_t || lang.name}
      </Box>
    );
  };
  return (
    <Flex gap={2} flexWrap="wrap" justifyContent="center">
      {param.values?.map(renderLang)}
    </Flex>
  );
};

export default QrLangSelect;
